import { Component, inject } from '@angular/core';
import { HeaderComponent } from 'src/app/header/header.component';
import { FooterComponent } from 'src/app/footer/footer.component';
import { RouterLink } from '@angular/router';
import { AuthenticationService } from '@core/services/auth.service';

@Component({
  selector: 'app-landing',
  templateUrl: './landing.component.html',
  standalone: true,
  imports: [HeaderComponent, FooterComponent, RouterLink],
})
export class LandingComponent {
  private authService = inject(AuthenticationService);

  signup(){
    this.authService.initiateULSignup();
  }
}
